import { ajaxErrorMessage } from "ajaxErrorMessage";
import * as appleAuth from "appleAuth";
import { htmlEscape } from "shared/utils";

/* global $: false */

declare global {
  interface Window {
    showModalDialog?: (
      dialog: JQuery<HTMLElement>,
      focusElement?: JQuery<HTMLElement>
    ) => void;
    chromeExtensionDialog?: JQuery<HTMLElement>;
    requireModules?: (
      dependencyNames: string[],
      module: (...args: any[]) => void
    ) => void;
  }
}

if (!window.console) window.console = console;
if (!window.console.log) window.console.log = () => {};
if (!window.console.time) window.console.time = () => {};
if (!window.console.timeEnd) window.console.timeEnd = () => {};
if (!window.console.assert) window.console.assert = () => {};
if (!window.console.error) window.console.error = () => {};

// include modules in hard coded hacky way for now to avoid requirejs overhead
(() => {
  const modules = {
    jquery: $,
    googleAuth: (() => {
      // re-defining localAPI function to avoid loading whole thing in landing page
      const setLocalMode = async (localMode) => {
        localStorage?.setItem("localMode", localMode);
      };

      let startedFetchingGoogleScript = false;
      let loaded = false;
      /** @type {((google: object) => void)[]} */
      let loadedCallbacks = [];

      const doWhenLoaded = (callback) => {
        if (!startedFetchingGoogleScript) {
          $.getScript("https://accounts.google.com/gsi/client", () => {
            loaded = true;
            // @ts-ignore
            const google = window.google;

            google.accounts.id.initialize({
              client_id:
                "600294213540-bfp4atl7c31mg86um6dcq2lvb635umom.apps.googleusercontent.com",
              callback: (response) => {
                // First make call to complete login to Readlang backend
                $.post("/api/auth/googleSignIn", {
                  idToken: response.credential,
                })
                  .done(() =>
                    (async () => {
                      // Redirect or refresh
                      await setLocalMode(false);
                      redirectToApp();
                    })()
                  )
                  .fail((jqXHR) => alert(ajaxErrorMessage(jqXHR)));
              },
            });

            for (const loadedCallback of loadedCallbacks) {
              // @ts-ignore
              loadedCallback(google);
            }
            loadedCallbacks = [];
          });
          startedFetchingGoogleScript = true;
        }

        if (loaded) {
          // @ts-ignore
          callback(window.google);
        } else {
          loadedCallbacks.push(callback);
        }
      };

      const redirectToApp = () => {
        window.location.pathname = "/startSignedIn";
      };

      const signOut = () => {
        doWhenLoaded((google) => {
          google.accounts.id.disableAutoSelect();
        });
      };

      const attachSignInClickHandler = (container) => {
        console.log("attach sign in handler");
        doWhenLoaded((google) => {
          google.accounts.id.renderButton(container, {
            theme: "filled_blue",
            size: "large",
            // Matches "Continue with Apple"
            text: "continue_with",
            width: Math.floor($(container).width()),
            locale: "en",
          });
        });
      };

      return {
        signOut: signOut,
        attachSignInClickHandler: attachSignInClickHandler,
      };
    })(),
    deviceDetect: (() => {
      // regexp or function to match each device
      const devices = {
        iOS: /iPad|iPhone|iPod/,
        android: /android/i,
        chrome: function () {
          return window.chrome && /chrome/i.test(navigator.userAgent);
        },
        firefox: /Firefox\//,
      };

      const is = (deviceName) => {
        const device = devices[deviceName];

        if (!device) {
          console.error('Device "%s" not recognised', deviceName);
          return false;
        } else if (typeof device === "function") {
          return device(navigator.userAgent);
        } else if (typeof device.test === "function") {
          return device.test(navigator.userAgent);
        }
        return false;
      };

      const info = () => {
        const result = {};
        Object.keys(devices).forEach((deviceName) => {
          if (is(deviceName)) {
            result[deviceName] = true;
          }
        });
        return result;
      };

      return {
        is: is,
        info: info,
      };
    })(),
  };

  window["requireModules"] = (dependencyNames, module) => {
    const dependencies = [];
    dependencyNames.forEach((moduleName) => {
      dependencies.push(modules[moduleName]);
    });
    module(...dependencies);
  };
})();

const setUpMobileMenu = () => {
  const mobileMenuToggle = $(".mobile_menu");
  const drawerContainer = $(".drawer_container");

  mobileMenuToggle.click(() => {
    if (mobileMenuToggle.hasClass("active")) {
      mobileMenuToggle.removeClass("active");
      drawerContainer.hide();
    } else {
      mobileMenuToggle.addClass("active");
      drawerContainer.show();
    }
  });
};

// copied from https://gist.github.com/1771618
const getUrlVar = (key: string, searchString?: string) => {
  const result = new RegExp(key + "=([^&]*)", "i").exec(
    searchString || window.location.search
  );
  return (result && decodeURIComponent(result[1])) || "";
};

window["requireModules"](
  ["googleAuth", "jquery", "deviceDetect"],
  (googleAuth, $, deviceDetect) => {
    // Smooth scroll from navbar
    if (history.pushState) {
      $(".topNavBar a").on("click", function (event) {
        // Get the absolute anchor href.
        const id = "#" + $(this).prop("href").split("#")[1];
        $(/WebKit/.test(navigator.userAgent) ? "body" : "html,body").animate(
          {
            scrollTop: $(id).offset().top - 20,
          },
          {
            duration: 800,
          }
        );

        history.pushState(null, null, id);

        // Stop the default event to ensure the link will not cause a page
        // refresh.
        event.preventDefault();
      });
    }

    // easing function from jQuery easing plugin:
    // http://gsgd.co.uk/sandbox/jquery/easing/jquery.easing.1.3.js
    $.easing.easeOut = (x, t, b, c, d) => -c * (t /= d) * (t - 2) + b;

    $(document).ready(() => {
      // Handle specific pages
      if ($("body").attr("id") === "couponPage") {
        setupCouponPage();
      }

      if (!deviceDetect.is("iOS") && deviceDetect.is("chrome")) {
        $("#bookmarklet").hide();
      } else {
        $("#chromeExtension").hide();
      }

      // fill redesigned main-row-top to screen height
      if ($("body").hasClass("redesign-stretch-height")) {
        const windowHeight = $(window).height();
        const topOfMainRow = $(".main-row").offset().top;
        const flagHeight = $(".flag-list").height();
        const topHeight = windowHeight - topOfMainRow - flagHeight - 40;

        if (topHeight > 550) {
          $(".main-row-top").css({
            height: topHeight,
          });
        }

        if (topHeight > 650) {
          $(".learn-more")
            .click(() => {
              $("html,body").animate(
                {
                  scrollTop: $("#how-it-works").offset().top,
                },
                {
                  duration: 800,
                }
              );
            })
            .show();
        }
      }

      $(".loginBox")
        .css({
          opacity: 0,
          visibility: "visible",
        })
        .animate({
          opacity: 1,
        });

      const formatNumber = (number) => {
        const thousands = Math.floor(number / 1000);

        if (thousands > 0) {
          const padding = "000";
          let smallNumberString = String(number - thousands * 1000);
          smallNumberString =
            padding.substring(0, 3 - smallNumberString.length) +
            smallNumberString;
          return formatNumber(thousands) + "," + smallNumberString;
        } else {
          return String(number);
        }
      };

      $.ajax({
        url: "/api/landingPageCounts",
        dataType: "json",
        success: function (data) {
          $(".statCount").eq(0).text(formatNumber(data.userCount));
          $(".statCount").eq(1).text(formatNumber(data.userWordCount));
          $(".statCount").eq(2).text(formatNumber(data.bookCount));

          $(".counter").fadeIn();
        },
      });

      const showLoginButton = $(".showLoginButton");
      const showResetPassword = $("#showResetPassword");
      const loginDialog = $("#loginDialog");
      const socialSignInButtons = loginDialog.find(".socialSignInButtons");
      const appleSignInButton = loginDialog.find(".appleSignInButton");
      const resetPasswordDialog = $("#resetPasswordDialog");
      const chromeExtensionDialog = $("#chromeExtensionDialog");
      const modalBackground = $("#modalBackground");
      const loginButton = $("#loginButton");
      const loginForm = $("form[name=login]");
      const resetPasswordButton = $("#resetPasswordButton");

      setUpMobileMenu();

      const dismiss = () => {
        $(".modalDialog").hide();
        modalBackground.hide();
      };

      modalBackground.click(dismiss);

      let fakeChromeExtensionInstallDialog = $(
        "#fakeChromeExtensionInstallDialog"
      );

      let chromeSuccessCallback;
      let chromeFailCallback;

      fakeChromeExtensionInstallDialog.find(".add").click(() => {
        fakeChromeExtensionInstallDialog.fadeOut();
        if (chromeSuccessCallback) {
          chromeSuccessCallback();
        }
      });
      fakeChromeExtensionInstallDialog.find(".cancel").click(() => {
        fakeChromeExtensionInstallDialog.fadeOut();
        if (chromeFailCallback) {
          chromeFailCallback();
        }
      });

      const showModalDialog = (dialog, focusElement) => {
        modalBackground.fadeIn();

        const offset = ($(window).height() - dialog.outerHeight()) / 2;
        dialog.css({
          top: $(window).scrollTop() + offset + 50 + "px",
          display: "block",
          opacity: 0,
        });
        dialog.animate(
          {
            top: $(window).scrollTop() + offset + "px",
            opacity: 1,
          },
          {
            easing: "easeOut",
          }
        );

        if (focusElement) {
          focusElement.focus();
        }
      };
      window.showModalDialog = showModalDialog;
      window.chromeExtensionDialog = chromeExtensionDialog;

      // Choosing email narrows the dialog to its fields, with a way back to
      // the other ways to sign in
      const showEmailSignIn = (emailSignIn: boolean) => {
        loginDialog.toggleClass("emailSignIn", emailSignIn);
        loginButton
          .find(".emailSignupText")
          .text(emailSignIn ? "Sign in" : "Sign in with email");
      };

      // Social sign-in stays reachable via "Other sign-in options", so make it
      // inert (Google's iframe ignores disabled) to not race the email login
      const setSubmitting = (submitting: boolean) => {
        loginDialog.toggleClass("submitting", submitting);
        socialSignInButtons.prop("inert", submitting);
      };

      const showLoginDialog = () => {
        showModalDialog(loginDialog, loginDialog.find("input[name=email]"));
        console.log("attaching sign in click handler");
        googleAuth.attachSignInClickHandler(
          loginDialog.find(".googleSignInButton")[0]
        );
        void appleAuth
          .prepare()
          .then((ready) => appleSignInButton.toggle(ready));
      };

      appleSignInButton.click(async () => {
        const failureMessage = "Sign in failed, please try again";
        try {
          // Opens Apple's popup at once, while the click allows it to
          const authorization = await appleAuth.authorize();
          const response = await fetch("/api/auth/appleSignIn", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(authorization),
          });
          if (!response.ok) {
            // e.g. an existing account whose address isn't verified
            alert(
              ajaxErrorMessage(
                { responseText: await response.text() },
                failureMessage
              )
            );
            return;
          }
        } catch (error) {
          if (!error.cancelled) {
            alert(failureMessage);
          }
          return;
        }
        localStorage?.removeItem("localMode");
        window.location.href = "/startSignedIn";
      });

      $("html").keyup((event) => {
        if (event.which == 27 /* Escape key */) {
          dismiss();
        }
      });

      showLoginButton.click((event) => {
        event.preventDefault();
        showLoginDialog();
      });

      showResetPassword.click((event) => {
        event.preventDefault();
        loginDialog.hide();
        resetPasswordDialog.show();
        resetPasswordDialog.find("input[name=email]").focus();
      });

      resetPasswordDialog.find("input[name=email]").keypress((event) => {
        if (event.which == 10 || event.which == 13) {
          resetPasswordButton.click();
        }
      });

      resetPasswordButton.click(() => {
        const email = resetPasswordDialog.find("input[name=email]").val();

        console.log("sending password reset to %s", email);

        $.ajax({
          type: "POST",
          url: "/api/forgotPassword",
          data: {
            email: email,
          },
          success: function () {
            alert(
              "If an account exists with this email, you should receive an " +
                "email with a link to reset your password soon."
            );
            dismiss();
          },
          error: function (jqXHR) {
            alert(ajaxErrorMessage(jqXHR));
          },
        });
      });

      loginForm.keypress((event) => {
        if (event.which == 10 || event.which == 13) {
          loginForm.submit();
        }
      });

      loginButton.click(() => {
        if (loginDialog.hasClass("emailSignIn")) {
          loginForm.submit();
        } else {
          showEmailSignIn(true);
          loginDialog.find("input[name=email]").focus();
        }
      });
      loginDialog
        .find(".otherSignInOptionsButton")
        .click(() => showEmailSignIn(false));
      // Only rendered in the local environment (landingPageDialogs.hbs).
      $("#signInAsSteveButton").click(async () => {
        const response = await fetch("/api/devSignInAsSteve", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });
        if (response.ok) {
          localStorage?.removeItem("localMode");
          window.location.href = "/startSignedIn";
        } else {
          alert((await response.json()).error);
        }
      });

      loginForm.submit((event) => {
        if (event) {
          event.preventDefault();
        }
        if (loginDialog.hasClass("submitting")) {
          return;
        }

        const email = loginDialog.find("input[name=email]").val();
        const password = loginDialog.find("input[name=password]").val();

        if (/^\S+@\S+\.\S+$/.test(email) && password.length > 3) {
          setSubmitting(true);

          // Use the page's own scheme so login works whether the app is served
          // over HTTPS (production) or HTTP (local dev reached via a .local
          // hostname, e.g. from the iOS app on a device).
          const protocol = window.location.protocol + "//";

          $.ajax({
            type: "POST",
            url: protocol + window.location.host + "/api/login",
            xhrFields: {
              withCredentials: true,
            },
            data: {
              email: loginDialog.find("input[name=email]").val(),
              password: loginDialog.find("input[name=password]").val(),
              rememberMe: loginDialog
                .find("input[name=rememberMe]")
                .is(":checked"),
            },
            success: function (data) {
              if (typeof data === "string") {
                data = JSON.parse(data);
              }

              if ("success" in data) {
                localStorage?.removeItem("localMode");
                window.location.href = "/startSignedIn";
              } else {
                $("#invalidCredentials").show();
                setSubmitting(false);
              }
            },
            error: function (jqXHR) {
              setSubmitting(false);
              alert(ajaxErrorMessage(jqXHR));
            },
          });
        } else {
          alert("Please enter a valid email and password");
        }
      });

      const urlEmail = getUrlVar("email", undefined);

      if (urlEmail) {
        console.log("email present");
        $("#loginDialog input[name=email]").val(urlEmail);
        showEmailSignIn(true);
        showLoginDialog();
        $("#loginDialog input[name=password]").focus();
      }

      const referrer = getUrlVar("ref", undefined);
      if (referrer) {
        localStorage?.setItem("referrer", referrer);
      } else if (!localStorage?.getItem("referrer")) {
        localStorage?.setItem("referrer", "landingPage");
      }

      if (
        !localStorage?.getItem("httpReferrer") &&
        !/readlang\.com/.test(document.referrer)
      ) {
        localStorage?.setItem("httpReferrer", document.referrer);
      }

      $.ajax({
        type: "POST",
        url: "/api/splitTests/trackEvent/landingPageLoaded",
        xhrFields: {
          withCredentials: true,
        },
        data: {
          properties: {
            "HTTP Referrer": document.referrer,
            Referrer: referrer,
          },
        },
      });
    });
  }
);

const setupCouponPage = () => {
  const couponToken = getUrlVar("token", undefined);

  $.ajax({
    type: "GET",
    url: `/api/coupon/lookupToken/${couponToken}`,
    xhrFields: {
      withCredentials: true,
    },
    dataType: "json",
    success: (data) => {
      renderCoupon(data);
    },
    error: (xhr, textStatus) => {
      console.error("unexpected error fetching coupon: ", textStatus);
    },
  });
};

const renderCoupon = (data) => {
  // If user is signed in, change the Sign In button to Enter
  // (Could consider fetching the user model and doing this on non-coupon pages too)
  if (data.user) {
    $(".sign_in_button").text("Enter");
  }

  if (!data.error) {
    $(".couponTitle").text("Redeem Your Coupon");
  }

  $(".couponContent").html(
    `<div>
      ${
        data.error
          ? ""
          : data.user
            ? `
        <h2>Redeem Your Coupon In One Simple Step!</h2>
        <p>
          Click the "Redeem Coupon" button below to apply this coupon to your account registered
          under the username ${htmlEscape(data.user.displayName || data.user.username)} (${htmlEscape(data.user.email)}).
        </p>
        `
            : `<h2>Redeem Your Coupon in 2 Easy Steps!</h2>
      <ol>
        <li>Click the "Redeem Coupon" button below.</li>
        <li>
          Follow the instructions which will appear to create or sign in to your Readlang account.
          Once signed in, your coupon will be automatically applied.
        </li>
      </ol>`
      }
      ${
        data.coupon
          ? `${renderCouponDetails(
              data.coupon
            )}${!data.error ? renderCTA() : ""}`
          : ""
      }
      ${data.error ? `<p>${renderError(data.error)}</p>` : ""}
    </div>`
  );

  $(".redeemButton").click(() => {
    $(".redeemButton").prop("disabled", true);
    localStorage?.setItem("couponToken", data.coupon.token);
    window.location.pathname = "/start";
  });

  $(".signInButton").click(() => {
    // Click the global sign in button
    $(".sign_in_button").click();
  });
};

const renderError = (error) => {
  switch (error) {
    case "coupon-not-found":
      return "Coupon not found";

    case "coupon-redeemed":
      return "This coupon has already been redeemed and can't be used again.";

    case "already-premium":
      return (
        "You can't redeem this coupon to your Readlang account because you already have a " +
        "premium subscription. <a href='/start'>Enter your account</a>."
      );

    default:
      return "An unexpected error occurred";
  }
};

const renderCouponDetails = (coupon) => {
  return `
    <div class="couponAndStamp">
      <div class="coupon${coupon.redeemed ? " redeemed" : ""}">
        <div class="couponLeft">
          <div class="topText">
            COUPON
          </div>
          <div class="bottomText">
            ${coupon.name}
          </div>
        </div>
        <div class="couponRight">
          <div class="topText">
            Readlang Premium
          </div>
          <div class="bottomText">
            ${coupon.months} MONTH${coupon.months === 1 ? "" : "S"}${coupon.name === "italki" ? " FREE" : ""}
          </div>
          <div class="couponToken">${coupon.token}</div>
        </div>
      </div>
      ${
        coupon.redeemed
          ? `
          <div class="stamp">
            REDEEMED
          </div>`
          : ""
      }
    </div>
  `;
};

const renderCTA = () => {
  return `
  <p style="text-align:center">
    <button class="button redeemButton drop-shadow">Redeem Coupon</button>
  </p>`;
};
